import React from 'react';
import { IconX } from "@tabler/icons-react";
import { notifications } from '@mantine/notifications';
import { modals } from '@mantine/modals';
import { Text, Button } from '@mantine/core';
import TestsApi from "../../api/TestsApi";
import { HelpTip } from "../../components/GeneralComponent/GeneralComponent";

export function UnsetWinner({
    SelectedThumbnail,
    SystemUsageLoader,
    SelectedMemberWebsite,
    MarkSalesTime,
  }:any) {


  const handleRemoveSetWinner = async (SelectedThumbnail) => {
    modals.openConfirmModal({
      trapFocus: false,
      title: 'Unset Winner',
      children: (
        <Text size="sm">
         Are you sure you want to remove "Set winner"?<br/>
         If you do this winner variation will stop being served to visitors, instead they will start seeing the control variation of the page again.
        </Text>
      ),
      labels: { confirm: 'Unset Winner', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onCancel: () => console.log('Cancel'),
      onConfirm: () => {
        handleUnsetwinner(SelectedThumbnail);
      },
    });
  }

  const handleUnsetwinner = async (SelectedThumbnail) =>{
    try {
      SystemUsageLoader(true);
      const APIResponse = await TestsApi.unsetwinner({
        page_id: SelectedThumbnail,
        system_website_id : SelectedMemberWebsite,
      });
      const APIResultJSON = await APIResponse.json();
      MarkSalesTime(APIResultJSON.data.updatedtime);
      if (APIResultJSON.status === 1) {
        SystemUsageLoader(false);
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
        SystemUsageLoader(false);
      }
    } catch (error) {
      SystemUsageLoader(false);
      console.error("API Error:", error);
    }
  };


  return (
    <>
      <Text weight={500}>
        <HelpTip helpId={306} />
      </Text>
      <Button color="red" type="button" style={{ marginLeft: 7 }} onClick={() => handleRemoveSetWinner(SelectedThumbnail)}>
        Remove "Set Winner"
      </Button>
    </>
  );
}